import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeletePhaseMutation} from '../hooks/usePhasesQuery';
import {usePhasesSelection} from "../hooks/usePhasesSelection.ts";


export const DeleteRecordButton = () => {

    const deletePhaseMutation = useDeletePhaseMutation();

    const {
        selection,
        handleClearSelection,
    } = usePhasesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deletePhaseMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
